// This file is generated automatically by scripts/generate-icon.js. Don't modify it.

import ArrowUp from '../_raw/ui/icon_arrow_up.svg';
import withIconProps from '../withIconProps';

export default withIconProps(ArrowUp);
